export default "/images/vendor/flag-icons/flags/4x3/ax.svg?dd048088f167a2fc17f43ceae4e6d25f";